import { UrlMatchResult, UrlSegment } from '@angular/router';

const SCOUT_PAGES: string[] = ['chat', 'results'];

export function matchScoutPage(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || (segments.length === 1 && SCOUT_PAGES.includes(segments[0].path))) {
    return { consumed: segments };
  }

  return null;
}
